export const FETCH_FEATURE_REQUEST = 'FETCH_FEATURE_REQUEST';
export const FETCH_FEATURE_SUCCESS = 'FETCH_FEATURE_SUCCESS';
export const FETCH_FEATURE_FAILURE = 'FETCH_FEATURE_FAILURE';